import { Dialog, DialogActions, DialogContent } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import { DoraButton, DoraTextInput } from "dora-shared/frontend";
import { useState } from "react";
import { useAppDispatch } from "../../../../redux-store";
import { updateDriverNote } from "../../../../ducks/data/cargo-events";
import { useTranslation } from "react-i18next";
import { loadIndividualCargoReport } from "../../../../ducks/data/cargos-report";

const EditDriverNoteDialog = ({
  onClose,
  data,
}: {
  onClose: () => void;
  data: {
    cargoId: string;
    note: string;
    id: string;
  };
}) => {
  const { t } = useTranslation(["components", "shipmentModal"]);
  const { cargoId, note, id } = data;
  const [text, setText] = useState<string>(note);
  const [reqInProgress, setReqInProgress] = useState(false);
  const dispatch = useAppDispatch();

  const onSaveClick = async () => {
    setReqInProgress(true);
    try {
      await dispatch(
        updateDriverNote({ cargoId, note: text, eventId: id })
      ).unwrap();
      dispatch(loadIndividualCargoReport({ cargoId }));
      onClose();
    } catch {
      // The updateDriverNote thunk has already reported it and shown the error toast.
    } finally {
      setReqInProgress(false);
    }
  };

  return (
    <Dialog open onClose={onClose}>
      <div style={{ minWidth: 500 }}>
        <DialogTitle>{t("shipmentModal:editDriverNote")}</DialogTitle>
        <DialogContent>
          <DoraTextInput
            autoFocus
            value={text}
            onChange={(value) => setText(value)}
          ></DoraTextInput>
        </DialogContent>
        <DialogActions>
          <div className="flex justify-end gap-2"></div>
          <DoraButton
            variant={"primary"}
            onClick={onClose}
            disabled={reqInProgress}
          >
            {t("components:buttonLabels.cancel")}
          </DoraButton>
          <DoraButton
            variant={"primary-filled"}
            disabled={reqInProgress || !text}
            onClick={onSaveClick}
          >
            {t("components:buttonLabels.save")}
          </DoraButton>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default EditDriverNoteDialog;
